// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.publicpage-bodytext {
	color: var(--scouting-america-pale-grey);

	padding-left: 20px;
	padding-right: 20px;
	padding-top: 5px;
	padding-bottom: 5px;

	font-size: var(--body-normal-size);
	text-align: left;
}

.publicpage-spacer {
	background-color: transparent;

	margin: 0;

	width: 100%;
}


@media (min-width: 751px) {
	.publicpage-spacer {
		height: 50px;
	}
}

@media (min-width: 451px) and (max-width: 750px) {
	.publicpage-spacer {
		height: 30px;
	}
}

@media (max-width: 450px) {
	.publicpage-spacer {
		height: 20px;
	}
}`, "",{"version":3,"sources":["webpack://./src/pages/PublicPage/PublicPage.css"],"names":[],"mappings":"AAAA;CACC,wCAAwC;;CAExC,kBAAkB;CAClB,mBAAmB;CACnB,gBAAgB;CAChB,mBAAmB;;CAEnB,kCAAkC;CAClC,gBAAgB;AACjB;;AAEA;CACC,6BAA6B;;CAE7B,SAAS;;CAET,WAAW;AACZ;;;AAGA;CACC;EACC,YAAY;CACb;AACD;;AAEA;CACC;EACC,YAAY;CACb;AACD;;AAEA;CACC;EACC,YAAY;CACb;AACD","sourcesContent":[".publicpage-bodytext {\n\tcolor: var(--scouting-america-pale-grey);\n\n\tpadding-left: 20px;\n\tpadding-right: 20px;\n\tpadding-top: 5px;\n\tpadding-bottom: 5px;\n\n\tfont-size: var(--body-normal-size);\n\ttext-align: left;\n}\n\n.publicpage-spacer {\n\tbackground-color: transparent;\n\n\tmargin: 0;\n\n\twidth: 100%;\n}\n\n\n@media (min-width: 751px) {\n\t.publicpage-spacer {\n\t\theight: 50px;\n\t}\n}\n\n@media (min-width: 451px) and (max-width: 750px) {\n\t.publicpage-spacer {\n\t\theight: 30px;\n\t}\n}\n\n@media (max-width: 450px) {\n\t.publicpage-spacer {\n\t\theight: 20px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
